import React from 'react';
import { Navbar, Nav, Button, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const handleNavLinkClick = () => {
    const navbarToggler = document.querySelector('.navbar-toggler') as HTMLButtonElement | null;
    const navbarCollapse = document.querySelector('.navbar-collapse');
    if (navbarCollapse?.classList.contains('show') && navbarToggler) {
      navbarToggler.click();
    }
  };

  return (
    <header className="sf-site-header">
      <div className="sf-topbar">
        <div className="sf-topbar-inner">
          <span>
            <i className="fas fa-map-marker-alt sf-topbar-location-icon" aria-hidden="true"></i>
            Raebareli, Uttar Pradesh, India
          </span>
          <span>
            <i className="fas fa-envelope sf-topbar-contact-icon" aria-hidden="true"></i>
            <a href="mailto:info@srisailamfoundation.org">info@srisailamfoundation.org</a>
            <span aria-hidden="true"> · </span>
            <i className="fas fa-phone sf-topbar-contact-icon" aria-hidden="true"></i>
            <a href="tel:+919838580001">+91 98385 80001</a>
            <span aria-hidden="true"> / </span>
            <a href="tel:+919450008921">+91 94500 08921</a>
          </span>
        </div>
      </div>
      <Navbar bg="light" variant="light" expand="lg" className="header sf-navbar px-3 px-lg-5">
        <Navbar.Brand as={Link} to="/" aria-label="Srisailam Foundation Home" className="sf-brand">
          <svg className="sf-demo-logo-mark" viewBox="0 0 44 44" aria-hidden="true" focusable="false">
            <rect width="44" height="44" rx="11.2" fill="#0b2e59" />
            <circle cx="22" cy="8.96" r="3.36" fill="#efa52b" />
            <path fill="#fff" fillRule="evenodd" d="M16.05 29.40V21.23L21.99 14.54L27.95 21.23V29.40Z M17.09 28.35H26.90V21.66L21.99 16.16L17.09 21.66Z" />
          </svg>
          <span className="sf-demo-logo-copy">
            <strong>Srisailam Foundation</strong>
            <small>Education · Opportunity · Brighter Futures</small>
          </span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="bg-dark border-dark" aria-label="Toggle navigation menu" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/" className="nav-link-custom" onClick={handleNavLinkClick}>
              Home
            </Nav.Link>
            <NavDropdown title="About" id="about-us-dropdown" className="nav-link-custom">
              <NavDropdown.Item as={Link} to="/about/" onClick={handleNavLinkClick}>
                About Srisailam Foundation
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/core-team/" onClick={handleNavLinkClick}>
                Leadership Team
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/mentors/" onClick={handleNavLinkClick}>
                Advisory Mentors
              </NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Programs" id="our-mission-dropdown" className="nav-link-custom">
              <NavDropdown.Item as={Link} to="/education/" onClick={handleNavLinkClick}>
                Education
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/women-empowerment/" onClick={handleNavLinkClick}>
                Women Empowerment
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/environment/" onClick={handleNavLinkClick}>
                Environment
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/health/" onClick={handleNavLinkClick}>
                Health
              </NavDropdown.Item>
            </NavDropdown>
            {/* <Nav.Link as={Link} to="/media/" className="nav-link-custom" onClick={handleNavLinkClick}>
              Media & Gallery
            </Nav.Link> */}
            <Nav.Link as={Link} to="/stories/" className="nav-link-custom" onClick={handleNavLinkClick}>
              Stories
            </Nav.Link>
            <NavDropdown title="Get Involved" id="get-involved-dropdown" className="nav-link-custom">
              <NavDropdown.Item as={Link} to="/become-member/" onClick={handleNavLinkClick}>
                Join as Member
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/volunteer" onClick={handleNavLinkClick}>
                Volunteer With Us
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/contact/" onClick={handleNavLinkClick}>
                Contact
              </NavDropdown.Item>
            </NavDropdown>
            <Link to="/donate/" className="nav-link-custom" onClick={handleNavLinkClick}>
              <Button variant="danger" className="header-donate-btn">
                Donate Now
              </Button>
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
};

export default Header;
